<template >
<div id="pdf">
  <!-- <v-bottom-navigation
    background-color="blue"
    color="white"
    horizontal
  >
    <v-btn>
      <span>Productos</span>

      <v-icon>mdi-package-variant-closed</v-icon>
    </v-btn>

    <v-btn to="/almacen">
      <span>Bodegas</span>

      <v-icon>mdi-hexagon-slice-6</v-icon>
    </v-btn>

    <v-btn>
      <span>Movimientos</span>

      <v-icon>mdi-file-replace-outline</v-icon>
    </v-btn>
  </v-bottom-navigation> -->

  <v-data-table
    :headers="headers"
    :items="getAllItems"
    :search="search"
    :items-per-page="5"
    class="elevation-1"
  >
    <template v-slot:top >
      <v-toolbar flat color="white" >
        <v-text-field
              v-model="search"
              type="text"
              append-icon="mdi-magnify"
              label="Buscar por producto..."
              single-line
              hide-details
              class="mr-3"
          ></v-text-field>
        <v-spacer></v-spacer>
        <v-divider class="mx-4" inset  vertical ></v-divider>
        <v-btn  color="primary"  dark class="mb-2" to="/almacen/nuevo">Nuevo</v-btn>
      </v-toolbar>
    </template>
    <template v-slot:[`item.stockactual`]="{ item }">
                    <p v-if="item.stockactual > 0">{{ item.stockactual }}</p>
                    <strong style="color:#757575" v-if="item.stockactual < 1">AGOTADO</strong>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        small
        color="blue"
        @click="editItem(item)"
        v-if="item.stockactual > 0"
        dark
      >
        <v-icon>mdi-plus-box</v-icon> AGREGAR
      </v-btn>
    </template>
    <template v-slot:no-data>
      <h2>No hay productos registrados :( </h2>
    </template>
  </v-data-table>

    <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"></v-card-title>
            <v-card-text>
              <v-text-field
                v-model="editedItem.cantidad"
                label="Cantidad"
                @keyup="calcular"
              ></v-text-field>
              <v-text-field
                v-model="editedItem.preciosugerido"
                label="Precio"
                @keyup="calcular"
              ></v-text-field>
              <v-text-field
                v-model="editedItem.total"
                label="Total"
                disabled
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog=false">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
     name:'Productos',  
     data: () => ({
      search:'',
      dialog: false,
      productos:[],
      editedIndex: -1,
      editedItem:{}, 
      headers:[
        { text: 'Cod.',align: 'center', value: 'codigo' },
        { text: 'Nombre', value: 'nombre'},
        { text: 'Stock Actual',align: 'center', value: 'stockactual' },
        { text: 'Precio Sugerido',align: 'center', value: 'preciosugerido' },
        { text: '',align: 'center', value: 'actions', sortable: false },
        ]
    }),

    computed: {
      getAllItems(){
        return this.$store.getters.getAllProductos
      },
      getTokenUser(){
        return this.$store.getters.getTokenUser
      }
    },
    async created () {
      await this.initialize()
    },

    methods: {  
      async initialize () {  
        await this.$store.dispatch('setProductos')   
        const datastorage = localStorage.getItem('productos') 
        if(datastorage)this.productos.push(JSON.parse(datastorage)) 
         
      },
      calcular(){
        this.editedItem.total = this.editedItem.cantidad * this.editedItem.preciosugerido
      },
     editItem (item) {
        item.cantidad = 1;
        const dato = this.productos.find(elemento=>elemento.idarticulo===item.idarticulo)
        this.editedIndex = this.productos.findIndex(elemento=>elemento.idarticulo===item.idarticulo)

        if(dato){
          this.editedItem = Object.assign({}, dato)
        }else{

          this.editedItem = Object.assign({}, item)
        }
        this.calcular()
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = {}
          this.editedIndex = -1
          //Guardamos los productos en LocalStorage
          localStorage.setItem('productos',JSON.stringify(this.productos))
        })
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.productos[this.editedIndex], this.editedItem)
        } else {
          this.productos.push(this.editedItem)
        }
        Swal.fire({
          icon: 'success',
          title: 'Realizado',
          showConfirmButton: false,
          timer: 1500
        })
        this.close()
      },

    },

    
}
</script>